<template>
  <div class="equity-contrast" v-show="showThis">
    <div id="qydb_close" @click="closeTab">
      <svg-icon name="DialogClose" size="10px"></svg-icon>
    </div>
    <p class="qydb_line">权益对比</p>
    <div class="qydb_table_box">
      <table
        class="qydb_table"
        border="1"
        cellspacing="0"
        cellpadding="0"
        frame="void"
        border-collapse="collapse"
      >
        <tbody>
          <tr style="height: 65px">
            <td style="font-size: 16px">权益对比</td>
            <td>
              <div class="qydb_icon">
                <svg-icon name="Qydb-Icon1"></svg-icon>
                <p>注册用户</p>
              </div>
            </td>
            <td>
              <div class="qydb_icon">
                <svg-icon name="Qydb-Icon2"></svg-icon>
                <p>图库会员</p>
              </div>
            </td>
            <td>
              <div class="qydb_icon">
                <svg-icon name="Qydb-Icon3"></svg-icon>
                <p>迷你CAD会员</p>
              </div>
            </td>
            <td>
              <div class="qydb_icon">
                <svg-icon name="Qydb-Icon4"></svg-icon>
                <p>超级会员</p>
              </div>
            </td>
            <td>
              <div class="qydb_icon">
                <svg-icon name="Qydb-Icon5"></svg-icon>
                <p>快速三维看图会员</p>
              </div>
            </td>
          </tr>
          <tr>
            <td>精品图库</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>PDF转CAD</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>DWG批量转PDF</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>识别图框打印</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>识别图框转PDF</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>批量转DXF</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>DXF转DWG</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>替换文字</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>提取文字</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>统一标注字高</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>提取表格文字</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>云盘扩容</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
          </tr>
          <!-- <tr>
            <td>CAD云图库</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr> -->
          <tr>
            <td>大文件上传</td>
            <td>最大100M图纸</td>
            <td>最大100M图纸</td>
            <td>最大1G图纸</td>
            <td>最大1G图纸</td>
            <td>最大1G图纸</td>
          </tr>
          <tr>
            <td>文件传输助手</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>离线登录</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>插入图框</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>图纸对比</td>
            <td>限时免费</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>建筑标注样式</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>图形统计</td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/right.png" alt="" /></td>
            <td><img src="@/assets/img/cadOld/x.png" alt="" /></td>
          </tr>
          <tr>
            <td>会员账号互通</td>
            <td>
              <p>迷你看图，迷你画图</p>
              <p>迷你家装</p>
            </td>
            <td>
              <p>迷你看图，迷你画图</p>
              <p>迷你家装</p>
            </td>
            <td>
              <p>迷你看图，迷你画图</p>
              <p>迷你家装</p>
            </td>
            <td>
              <p>迷你看图，迷你画图</p>
              <p>迷你家装</p>
            </td>
            <td>快速三维看图</td>
          </tr>
          <tr style="height: 85px">
            <td>查看三维格式图纸</td>
            <td>仅支持DWG格式</td>
            <td>仅支持DWG格式</td>
            <td>仅支持DWG格式</td>
            <td>仅支持DWG格式</td>
            <td>
              <p>
                支持查看CATIA、 ProE/CreoParametric3D、 SOLIDWORKS3D、 UGNX3D、Solidedge
                五种主流格式
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="zhu">
      注：注册用户迷你看图无法使用迷你会员功能，迷你画图、迷你家装、手机版迷你看图可试用所有功能，但无法保存、打印、转出（PDF和图片）
    </p>
  </div>
  <div class="mask" v-show="showThis"></div>
</template>

<script setup>
import { ref, defineProps, defineEmits, toRefs } from 'vue'

/* --- props --- */
const props = defineProps({
  showThis: {
    type: Boolean
  }
})
/* --- emit --- */
const emit = defineEmits(['update:showThis'])

/* --- 全局变量 --- */
var { showThis } = toRefs(props)

/* --- 函数方法 --- */
function closeTab() {
  emit('update:showThis', false)
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_make.scss';

.equity-contrast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  background-color: #fff;
  z-index: 9999;
  @include responsive-style(
    (
      top: 150px,
      width: 780px,
      height: 500px
    )
  );

  #qydb_close {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @include responsive-style(
      (
        top: -3px,
        right: 5px,
        width: 36px,
        height: 36px
      )
    );

    .svg-icon {
      @include responsive-style(
        (
          width: 12px,
          height: 12px
        )
      );
    }
  }

  .qydb_line {
    border-bottom: 1px solid rgba(204, 206, 208, 1);
    color: rgba(102, 102, 102, 1);
    text-indent: 1rem;
    @include responsive-style(
      (
        padding-bottom: 5px,
        margin-top: 5px,
        font-size: 14px
      )
    );
  }

  .qydb_table_box {
    overflow-y: scroll;
    @include responsive-style(
      (
        height: 418px
      )
    );

    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #adb1b7;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: white;
    }

    .qydb_table,
    .qydb_table tr,
    .qydb_table tr td {
      @include responsive-style(
        (
          border: 1px solid rgba(242, 243, 245)
        )
      );
    }

    .qydb_table {
      text-align: center;
      border-collapse: collapse;
      @include responsive-style(
        (
          width: 740px,
          height: 819px,
          margin: 30px auto 0
        )
      );

      tr td {
        color: rgba(51, 51, 51, 1);
        @include responsive-style(
          (
            width: 128px,
            font-size: 12px
          )
        );
      }

      tr:first-child td {
        color: rgba(102, 102, 102, 1);
        @include responsive-style(
          (
            font-size: 14px
          )
        );
      }

      .qydb_icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include responsive-style(
          (
            height: 65px
          )
        );

        p {
          @include responsive-style(
            (
              margin-top: 8px
            )
          );
        }

        .svg-icon {
          @include responsive-style(
            (
              width: 24px,
              height: 24px
            )
          );
        }
      }
    }
  }

  .zhu {
    margin: 0 auto;
    letter-spacing: 0px;
    color: rgba(102, 102, 102, 1);
    @include responsive-style(
      (
        width: 730px,
        height: 31px,
        margin-top: 11px,
        font-size: 12px,
        line-height: 18px
      )
    );
  }
}
.mask {
  z-index: 999;
}
</style>
